import { DragEvent, useState } from 'react';

type UseDraggableReorderParams = {
  id: string;
  dataTransferKey?: string;
  onReorder: (draggedId: string, targetId: string) => void;
};

export const useDraggableReorder = ({ id, dataTransferKey = 'case-tab-id', onReorder }: UseDraggableReorderParams) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragStart = (e: DragEvent<HTMLElement>) => {
    e.dataTransfer.setData(dataTransferKey, id);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e: DragEvent<HTMLElement>) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e: DragEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const draggedId = e.dataTransfer.getData(dataTransferKey);

    setIsDragOver(false);

    if (!draggedId || draggedId === id) return;

    onReorder(draggedId, id);
  };

  const handleDragEnd = () => {
    setIsDragOver(false);
  };

  return {
    isDragOver,
    draggableProps: {
      draggable: true,
      onDragStart: handleDragStart,
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
      onDragEnd: handleDragEnd,
    },
  };
};
